/* eslint-disable */
export default {
  ringtones: 'Ruftöne',
  incomingRingtone: 'Klingelton für eingehende Anrufe',
  outgoingRingtone: 'Klingelton für ausgehende Anrufe',
  play: 'Abspielen',
  stop: 'Anhalten',
  upload: 'Hochladen',
  reset: 'Zurücksetzen',
  save: 'Speichern',
} as const;

// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"incomingRingtone"@#@ @source: @#@"Incoming Ringtone"@#@
// @key: @#@"outgoingRingtone"@#@ @source: @#@"Outgoing Ringtone"@#@
// @key: @#@"play"@#@ @source: @#@"Play"@#@
// @key: @#@"stop"@#@ @source: @#@"Stop"@#@
// @key: @#@"upload"@#@ @source: @#@"Upload"@#@
// @key: @#@"reset"@#@ @source: @#@"Reset"@#@
// @key: @#@"save"@#@ @source: @#@"Save"@#@
